<template>
  <div class="panel-body">
    <div>
      <fieldset class="border">
        <legend class="border"><b>広告の運用</b></legend>
        <div class="text-left">
          <div class="radio-inline">
            <input type="radio" value="1" id="promotion-on" v-model="promotionRequest.promotionFlg" data-vv-scope="form-on">
              <label for="promotion-on">申し込む</label>
          </div>
          <div class="radio-inline">
            <input type="radio" value="0" id="promotion-off" v-model="promotionRequest.promotionFlg" data-vv-scope="form-off">
              <label for="promotion-off">申し込まない</label>
            &nbsp;
            &nbsp;
          </div>
          <button class="btn btn-warning w-120" @click.prevent="updatePromotionRequest">更新</button>
        </div>
      </fieldset>
      <br>
      <div>
        <fieldset class="border">
          <legend class="border" v-if="promotion"><b>{{ promotion.title }}</b></legend>
          <div class="text-left">
            <div v-if="promotion" v-html="replaceHTMLSellerInfo(promotion.content)"></div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>
<script>
import Const from '@/common/msg'
import PromotionService from '@/services/promotionservice'
import SettingService from '@/services/settingservice'
import store from '@/store'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      err: null,
      promotion: null,
      loader: null,
      promotionRequest: {
        promotionFlg: '0'
      }
    }
  },

  created () {
    this.getUserInfo()
    this.getPromotionDiscription()
  },

  computed: {
    isPromotionFlg () {
      return this.promotionRequest.promotionFlg === '1'
    },
    scope () {
      return this.isPromotionFlg ? 'form-on' : 'form-off'
    }
  },

  methods: {
    replaceHTMLSellerInfo,
    async getUserInfo () {
      try {
        const response = await SettingService.getSellerInformation()
        if (Object.keys(response).length !== 0) {
          this.promotionRequest.promotionFlg = response.seller.promotionFlg
        }
      } catch (err) {
        this.err = err
        this.userInfo.promotionFlg = '0'
      }
    },

    async getPromotionDiscription () {
      let self = this
      PromotionService.getPromotionDiscription()
        .then((response) => {
          self.promotion = response['promotion'][0]
        })
        .catch((error) => {
          self.err = error
        })
        .finally(() => {
          if (this.$route.params.tab === 'top') {
            this.$events.fire('done')
          }
        })
    },
    async updatePromotionRequest () {
      let self = this
      let user = self.$store.getters.getUser
      let logParams = {
        name: eventCode.promotion.top_tab.click_update_button,
        properties: {
          oldUserPromotionFlg: user.promotionFlg,
          newUserPromotionFlg: self.promotionRequest.promotionFlg
        }
      }
      EventService.postTrackLog(logParams)

      user.promotionFlg = self.promotionRequest.promotionFlg
      self.loader = self.$loading.show()
      const payload = {
        record: {
          promotionFlg: user.promotionFlg
        }
      }
      PromotionService.updatePromotion(payload)
        .then((response) => {
          store.commit('toggleModal', {
            show: true,
            message: Const.updateSuccess
          })
          store.commit('setUser', user)
          self.$emit('checkData', true)
        })
        .catch((err) => {
          store.commit('toggleModal', {
            show: true,
            message: err
          })
          self.err = err
        })
        .finally(() => {
          self.loader && self.loader.hide()
        })
    }
  },

  mounted () {
    if (this.currentTab && this.currentTab === 'top') {
      let logParams = {
        name: eventCode.promotion.top_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/promotion/Top.vue